export default "__VITE_ASSET__CnFeBiRR__"